import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Sorter from "./sorter";
import { AUTHORS_SORT_TYPES } from "../../../../../../common/constants";
import { Button, Input, InputGroup, InputGroupText } from "reactstrap";
import Spinner from "../../../../../common/loader/components/spinner";

const AuthorFilterBar = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    props.changeSearchCriteria(
      { sort: AUTHORS_SORT_TYPES.last_name },
      "authorsFilter",
      props.actionType
    );
  }, []);
  const onSearchClicked = (e) => {
    e.preventDefault();
    props.getAuthors({ pageCount: 0 });
  };
  function onSearchInputChange(e) {
    props.changeSearchCriteria(
      { criteria: e.target.value },
      "authorsFilter",
      props.actionType
    );
  }
  const authors_sort = {
    title: t("authors-sort-title"),
    onClick: ({ target }) => {
      props.changeSearchCriteria(
        { sort: target.value },
        "authorsFilter",
        props.actionType
      );
    },
    items: [
      {
        text: t("authors-sort-last-name"),
        value: AUTHORS_SORT_TYPES.last_name,
        selected: AUTHORS_SORT_TYPES.last_name === props.filterParams.sort,
      },
      {
        text: t("authors-sort-most-titles"),
        value: AUTHORS_SORT_TYPES.most_titles,
        selected: AUTHORS_SORT_TYPES.most_titles === props.filterParams.sort,
      },
    ],
  };

  const icon =
    props.authors.length < 1 ? (
      <Spinner style={{ height: "16px", color: "white" }} />
    ) : (
      <span className=" fa fa-search fa-4 " />
    );
  return (
    <form onSubmit={onSearchClicked}>
      <InputGroup>
        <InputGroupText>{t("search")}</InputGroupText>
        <Input
          type="text"
          value={props.filterParams.criteria ? props.filterParams.criteria : ""}
          onChange={onSearchInputChange}
          placeholder={t("last-name")}
          id="lastNameSearch"
        />
        <InputGroupText>{t("authors-sort-title")}</InputGroupText>

        <Sorter sorts={authors_sort} />

        <Button type="sub" onClick={onSearchClicked}>
          {icon}
        </Button>
      </InputGroup>
    </form>
  );
};

export default AuthorFilterBar;
